import { styled } from '@mui/system'

export const ScanIndicatorWrapper = styled('div')`
    margin-left: auto;
`
